import "./../css/sass/styles.scss";

import './global';
import './jquery.scrollTo';
import './skip-link-focus-fix';
import "babel-polyfill";
// import locomotiveScroll from 'locomotive-scroll';
import Modal from './components/accessibility';

// import 'jquery-equal-height';
import form_selects from './components/form-selects';
import beer_quiz from './components/beer-quiz';
import slider from './components/slider';
import modal from './components/modal';
import nav from './components/nav';
import animations from './components/animations';
import beer_filter from './components/beerFilter';
// import scrollSlider from './components/scrollSlider';
import events from './components/events';

function id(v){ return document.getElementById(v); }


function setCookie(cname, cvalue, exdays) {
  let expires = '';
  if(exdays){
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      expires = "expires="+d.toUTCString()+';';
  }
  document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie(cname) {
  var agegateVerified = getCookie(cname);
  if (agegateVerified != "") {
      return true;
  }
}

// Youtube()
function td_stamp() {
    console.log(' _____ _____   ____   _  __  _   ____  ');
    console.log('|_   _|| () ) / () \\ | ||  \\| | / () \\ ');
    console.log('  |_|  |_|\\_\\/__/\\__\\|_||_|\\__|/__/\\__\\');
    console.log('Powered By Traina Design, 2019');
    console.log('Website troubles? Service@trainadesign.com');
}

function td_trigger_animations_start() {
    var $_curtain = id('brooklyn__curtain');
    var $_loadStatusText = id('loadStatusText');
    const $_filterWrapper = $('#filter-wrapper');
    var $_agegate = $('.age-gate-wrap');

    $_curtain.classList += ' active';
    document.getElementById('header').getElementsByClassName('row__header')[0].classList += ' in-viewport';
    // $('#header .row__header').addClass('in-viewport');

    // setTimeout(function(){
        $('#header .row__header .main-navigation > li, #header .row__header .util-nav > li').addClass('is-inview');
        $('.section__hero .lp-hero__slide.first, #header .row__header').addClass('in-viewport');
        if($_filterWrapper.length) {
            $_filterWrapper.addClass('is-inview');
            $_filterWrapper.find('.anim-elem').addClass('is-inview');
        }
    // }, 500);
}

// Handle closing the agegate
$('.age-gate-wrap .form-submit.yes').click(function(evt) {
        evt.preventDefault();
        var rememberMe = $('.age-gate-wrap input[type="checkbox"]:checked');
        if($(rememberMe).length){
            setCookie('agegate', 'true', 365);
        }
        else {
            setCookie('agegate', 'true');
        }
        $('.age-gate-wrap').addClass('animate-out');
        $('html').removeClass('scroll-lock');

        var target = $('.age-gate-wrap, #cookie-law-info-bar');
        // Handles un-trapping focus in modal
        Modal.close($(target));
});

// Handle checking cookies to see if the remember me link can be displayed
function showAgeGateRemember(){
    if(getCookie('viewed_cookie_policy') == 'yes' && getCookie('cookielawinfo-checkbox-non-necessary') == 'yes'){
        const checkbox = $('.age-gate-wrap input[type="checkbox"]');
        $(checkbox).prop('disabled', function(i, v) { return !v; });
        $(checkbox).closest('.checkbox-wrap.disabled').removeClass('disabled');
    }
}
showAgeGateRemember();

$('body').on('click keydown','#cookie-law-info-bar a', function(event){
    showAgeGateRemember();

    // Make sure using enter key works on cookie bar links
    var keycode = (event.keyCode ? event.keyCode : event.which);
	if(keycode == '13'){
		$(this).trigger('click');
	}
});

/*
 YOUTUBE VIDEO
 */
function onYouTubeIframeAPIReady() {
    // 1. This function creates an <iframe> (and YouTube player) //    after the API code downloads.
    var videoID = $('#player').attr('data-rel');
    if(videoID) {
        player = new YT.Player('player', {
            width: '1140',
          height: '641',
          videoId: videoID,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
            },
            playerVars: {
                'rel' : 0,
                'fs' : 0,
                'controls' : 1
            }
        });
    }
}
function onPlayerReady(event) {
    // 2. The API will call this function when the video player is ready.
    var playButton = document.getElementById("video__playbutton_1");
    var vid = document.getElementById('video__elem');
    vid.playbackRate = 0.625;
    playButton.addEventListener("click", function() {
        player.playVideo();
        $('.video__wrapper').addClass('video-active hide--loop');
    });
}
function onPlayerStateChange(event) {
    // 3. The API calls this function when the player's state changes.
    setTimeout(function(){
        if(event.data == 1 || event.data == 3) {
            $('.video__wrapper').addClass('video-active');
        } else {
            $('.video__wrapper').removeClass('video-active hide--loop');
        }
    }, 350);
}
function stopVideo() {
    // 4. This API will stop the video
    player.stopVideo();
}

// used for window resize functions to reduce function calls
function debouncer( func , timeout ) {
    var timeoutID , timeout = timeout || 20;
    return function () {
        var scope = this , args = arguments;
        clearTimeout( timeoutID );
        timeoutID = setTimeout( function () {
            func.apply( scope , Array.prototype.slice.call( args ) );
        } , timeout );
    };
}

// Object fit polyfill
// objectFitImages();

// function td_trigger_matchHeight() {
//     td_trigger_matchHeight();
// }
// import accordion from './components/accordion';
// import Youtube from "./components/youtube-api";
// import locomotive from "./components/locomotive";

// Use this file for all your js need
$(document).ready(() => {
    // bootstrap accordion
    $('.collapse').collapse({
        toggle: false
    });

    // Track beer finder button clicks
    $('.beerFinderLink').on('click', function(e){
      ga('send', { 
        hitType: 'event', 
        eventCategory: 'Find It Near You Button', 
        eventAction: 'click'
      });
    });

    // Gravity Forms File Upload Button
    $('.ginput_container_fileupload').each(function(){
        $(this).append('<div class="upload-overlay-button"><span class="label">Browse files</span><span class="arrow"></span></div>');

        var label = $(this).find('.upload-overlay-button .label'),
            labelVal = label.html(),
            input = $(this).find('input[type=file]');

        input.on( 'change', function( e )
		{
			var fileName = '';

			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else if( e.target.value )
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				label.html( fileName );
			else
				label.html( labelVal );
		});

		// Firefox bug fix
		input
		.on( 'focus', function(){ input.addClass( 'has-focus' ); })
		.on( 'blur', function(){ input.removeClass( 'has-focus' ); });
    });

    // Email Signup email field confirmation UI
    // first, display the second field once the first field has a value.
    $('.mc-form.gform #input_9_1').on('input', function(){
        const form = $('.mc-form.gform');
        const email1 = $(this);
        const email2 = form.find('#input_9_1_2');

        if(email1.val().length < 1){
            form.removeClass('confirm_active');
            email2.val('');
        }
        else {
            form.addClass('confirm_active');
        }
    });
    // $('#mc_embed_signup #mc-embedded-subscribe').click(function(e){
    //     const form = $('#mc_embed_signup');
    //     const fieldGroup = form.find('.mc-field-group');
    //     const email1 = $('#mc_embed_signup #mce-EMAIL');
    //     const email2 = $('#mc_embed_signup #mce-EMAIL-CONFIRM');
    //
    //     if(email1.val() !== email2.val()){
    //         form.addClass('email_mismatch');
    //         email1.addClass('mce_inline_error');
    //
    //         if(!fieldGroup.find('.email_mismatch_error').length){
    //             fieldGroup.append("<div class='mce_inline_error email_mismatch_error' style='display:block;'>Email addresses don't match.</div>");
    //         }
    //
    //         e.preventDefault();
    //     }
    //     else if(form.hasClass('email_mismatch')){
    //         form.removeClass('email_mismatch');
    //         form.find('.email_mismatch_error').remove();
    //     }
    // });

    function body_scroll_class(){
        const windowScroll = $(window).scrollTop();
        if(windowScroll > 300){
            $('body').addClass('scrolled');
        }
        else {
            $('body').removeClass('scrolled');
        }
    }
    body_scroll_class();
    $(window).scroll(debouncer(function(){
        body_scroll_class();
    }, 10));

    // Remove empty p tags automatically placed by wordpress editor
    $('.entry-content p').each(function(){
        var content = $(this).html();
        var content = content.replace(/\s+/g, '');
        if(!content){
            $(this).remove();
        }
    });

    // Set Divs to Equal Heights
    function equalHeights() {
        $('.equalHeightContainer').each(function(index, element) {
            var parent = element;
            var maxHeight = 0;
            $(parent).find('.equalHeightsMeasure').each(function(){
                var height = $(this).outerHeight();
                if(height > maxHeight){
                    maxHeight = height;
                }
            });

            // Set each height to the max height
            $(parent).find('.equalHeightsSet').height(maxHeight);
        });
    };
    equalHeights();

    // Check blockquote br to avoid widows
    function blockQuoteBR() {
        $('.block__quote__text').each(function(index, element){
            var container = $(element).children('span').not('.block__quote__quote');
            if($(container).find('br').length){
                // First, on blockquotes that include br elements, split the content of
                if(!$(container).hasClass('split')){
                    var words = $(container).html().split(" ");
                    $(container).empty();
                    $.each(words, function(i, v) {
                        if (v.indexOf("<br>") >= 0 || v.indexOf('<BR>') >= 0 || v.indexOf('</br>') >= 0){
                            var subWords = v.split(">");
                            $.each(subWords, function(i, v) {
                                if (v.indexOf("<br") >= 0 || v.indexOf('<BR') >= 0 || v.indexOf('</br') >= 0){
                                    $(container).append('<br>');
                                } else {
                                    $(container).append($("<span>").text(v+' '));
                                }
                            });
                        } else {
                            $(container).append($("<span>").text(v+' '));
                        }
                    });

                    $(container).addClass('split');
                }

                // Next, check left position of the word in front of the br to see if it's the beginning of a new row
                $(container).find('br').each(function(index, element){
                    var br = element;
                    if($(br).prev().position().left == 0){
                        $(br).addClass('disabled');
                    } else {
                        $(br).removeClass('disabled');
                    }
                });
            }
        });
    }
    blockQuoteBR();

    // Smooth Scrolling links
    $('body').on('click', '.scroll-link', function(e){
      e.preventDefault();
      const target = $(this).attr('href');
      if($('body').find(target).length){
        const targetPos = $(target).offset().top - 30;
        $('html,body').animate({scrollTop: targetPos}, 800);
      }
    });

    // Resize iFrames
    // Stopped use as it does not work on wpengine.
    // $('#beer-finder-frame').iFrameResize( { log:true, resizeFrom:'parent', bodyMargin:'20px 0', heightCalculationMethod: 'lowestElement' });

    // // Fallback for iframeresizer not working on wpengine
    // $('.beer-finder-scroll').click(function(e){
    //     e.preventDefault();
    //     $(this).blur();
    //     $('#beer-finder-content').animate({scrollTop: 0}, 800);
    //
    //     if($(this).closest('.beer-finder-content-wrap').length){
    //         const scrollPos = $('.beer-finder-content-wrap').offset().top;
    //         $('html,body').animate({scrollTop: scrollPos}, 800);
    //     }
    // });
    //
    // $( '#beer-finder-content' ).scroll(function ( e ) {
   	// 	const elem = $( '#beer-finder-content' );
    //     const scrollLink = $('.beer-finder-scroll');
    //     const scrollPos = elem.scrollTop();
    //     if(scrollPos > 300) {
    //         scrollLink.addClass('scroll-active');
    //     } else {
    //         scrollLink.removeClass('scroll-active');
    //     }
   	// });

   	$( window ).resize( debouncer( function ( e ) {
   		equalHeights();
        blockQuoteBR();
   	} ) );

    // Blog share links
    $('.share__link').click(function(e){
        e.preventDefault();
        $(this).blur();
        $('.share__icons').toggleClass('active');
    });

    // Adjust screen position when accordions open
    $('.accordion__trigger').click(function(e){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            return;
        }
        const container = $(this).closest('.block__accordion__items');
        const currentParent = $(this).closest('.accordion__item');
        const scrollPaddingTop = 150;
        let active = container.find('.accordion__trigger.active');
        let currentIndex = currentParent.index();

        let scrollPosition;
        let activeParent
        let activeHeight;
        let activePadding;
        let activeIndex;

        // Check if there is an active element, and if so, get it's index
        if(active.length){
            activeParent = active.closest('.accordion__item');
            activeIndex = activeParent.index();
        }

        // Check if active element is above the current element
        if(activeIndex < currentIndex){
            activeHeight = activeParent.outerHeight();
            activePadding = activeHeight - activeParent.innerHeight();
            activeHeight = activeHeight - activePadding - activeParent.find('.accordion__header').outerHeight();
            scrollPosition = currentParent.offset().top - activeHeight - scrollPaddingTop;
        } else {
            scrollPosition = currentParent.offset().top - scrollPaddingTop;
        }

        $('html,body').animate({scrollTop: scrollPosition}, 800);

        active.removeClass('active');
        $(this).addClass('active');
    });


    // Check if a link has a mailto: href, and if so, prevent the beforeunload from firing below.
    $('body').on('click', 'a', function(){
      const href = $(this).attr('href');
      const isMailTo = href.indexOf('mailto:') > -1 ? true : false;
      window.mailToClicked = isMailTo;
    });

    // Show curtain before leaving page
    // $(window).on('beforeunload', function() {
    //   if(!window.mailToClicked){
    //     $('body').addClass('animate-out');
    //   }
    //   else {
    //     window.mailToClicked = false;
    //   }
    // });
});


$(window).on('load', function() {
    td_stamp();

    // Check if Element is on screen
	$.fn.isOnScreen = function(){
		if($(this).length) {

		// Percentage of screen height to offset the trigger. e.g. 2 equals 50% or mid-screen
		var offsetTriggerAmount = 6;

		var top = $(this).offset().top;
		var bottom = top + $(this).outerHeight();
		var windowTop = $(window).scrollTop();
		var windowBottom = windowTop + $(window).height();
		var triggerTop = windowTop + ($(window).height() / offsetTriggerAmount);
		var triggerBottom = windowBottom - ($(window).height() / offsetTriggerAmount);


		return ((top < triggerBottom && bottom > triggerBottom) || (top < triggerTop && bottom > triggerTop) || (top > windowTop && bottom < windowBottom));
		}
		else {
		return false;
		}
	};

    // since locomotive scroll can be a bit unreliable for animating in elements, this function works as a backup.
    // function is_inview_scrollcheck(){
        $('[data-scroll]').each(function(){
            // if($(this).isOnScreen() && !$(this).hasClass('in-inview')){
                $(this).addClass('is-inview');
            // }
        });
    // }

    window.almComplete = function(alm){
    	$('.alm-masonry img').trigger('load');
    };


    // const mainScroll = new locomotiveScroll({
    //     el: document.getElementById('page'),
    // });
    // mainScroll.on('call', (func) => {});

    // Update locomotiveScroll when UI elements change scroll positions
    // const ui_elements = document.querySelectorAll('.accordion__trigger, .tab-links a, .nav-tabs a');
    // for(var i = 0; i < ui_elements.length; i++) {
    //     let el = ui_elements[i];
    //     el.addEventListener('click', function(e){
    //         el.blur();
    //         // Set timeout to ensure elements position has updated
    //         setTimeout(function(){
    //             is_inview_scrollcheck();
    //         },75);
    //         setTimeout(function(){
    //             is_inview_scrollcheck();
    //         },150);
    //         setTimeout(function(){
    //             is_inview_scrollcheck();
    //         },300);
    //     });
    // };
    // Update on scroll when on pages that posts loaded in with ajax
    // const ajaxLink = document.querySelectorAll('.alm-load-more-btn');
    // const filterLink = document.getElementById('filter-wrapper');
    // if((ajaxLink !== null && ajaxLink.length) || (filterLink !== null && filterLink.length)){
    //     $( window ).scroll( debouncer( function ( e ) {
    //         mainScroll.update();
    //     }, 100 ) );
    // }
    // Update on age gate verification
    // $('body').on('click','.age-gate-submit', function(){
    // $('body').on('click','.age-gate-wrap .form-submit', function(){
    //     setTimeout(function(){
    //         mainScroll.update();
    //     },2000);
    // });
    // Also update locomotiveScroll on window resize
    // $( window ).resize( debouncer( function ( e ) {
    //     setTimeout(function(){
    //         mainScroll.update();
    //     },500);
    // } ) );


    if($('#scroller').length) {
        var pageScrollHelper = bodymovin.loadAnimation({
           container: document.getElementById('scroller'), // Required
           path: '/wp-content/themes/brooklyn/assets/animations/scroll.json', // Required
           renderer: 'svg', // Required
           loop: true, // Optional
           autoplay: true, // Optional
           name: "Page Scroll Indicator", // Name for future reference. Optional.
       });
       pageScrollHelper.play();
   }

var ovrl = id("brooklyn__curtain"),
    prog = id("progress"),
    stat = id("progstat"),
    img = document.images,
    c = 0,
    tot = img.length;
    // Preload images
    const preloadImages = () => {
        return new Promise((resolve, reject) => {
        var imgLoad = imagesLoaded(document.querySelectorAll('img'), {
            background: true,
            }, resolve);
            imgLoad.on('progress', function(instance, image) {
                /* UNCOMMENT FOR INTERVAL COUNTER
                c += 1;
                var perc = ((100/tot*c) << 0) +"%";
                prog.style.width = perc;
                stat.innerHTML = perc + " Loaded";
                */
            });
        });
    };

    if(checkCookie('agegate')) {
        $('.age-gate-wrap').addClass('hidden');
    } else {
        $('html').addClass('scroll-lock');
        var target = $('.age-gate-wrap, #cookie-law-info-bar');
        // Handles trapping focus in age gate
        Modal.open($(target));
    }
    preloadImages().then(() => {
        td_trigger_animations_start();

        // trigger scroll helper for animations.
        // wait for curtain to close then run it.
        // setTimeout(function(){
        //     is_inview_scrollcheck();
        // }, 500);

        // $(window).on('scroll', debouncer(function(){
        //     is_inview_scrollcheck();
        // }, 10));
    });

});



